import { getFontTokenStyle, marginBottomSpacing } from '@koaly/mixins';
import { withExtra } from '@koaly/with-extra';
import React from 'react';
import styled from 'styled-components';

const StyledHeading = styled.h1 `
  /* Reset */
  margin: 0;

  /* Style */
  white-space: pre-wrap;
  ${({ size, variant }) => getFontTokenStyle('heading', size, variant)};
  ${({ spaceAfter }) => spaceAfter && marginBottomSpacing(spaceAfter)};
`;
const Heading = withExtra(({ size, children, spaceAfter, as, onClick, id, variant }, ref) => {
    return (React.createElement(StyledHeading, { as: as ? as : size === 'mega' ? 'h1' : size, size: size, ref: ref, onClick: onClick, spaceAfter: spaceAfter, variant: variant, id: id }, children));
}, { name: 'Heading' });
Heading.defaultProps = {
    size: 'h2',
};

export { Heading, StyledHeading };
//# sourceMappingURL=Heading.js.map
